import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    getModulesRequest,
    addModuleRequest,
    getModulesSuccess,
    getModulesError,
    addModuleSuccess,
    addModuleError,
    deleteModuleRequest,
    deleteModuleSuccess,
    deleteModuleError,
    editModuleRequest,
    editModuleSuccess,
    editModuleError,
    getModulesReset,
} from './index';
import { addModule, deleteModule, editModule, getModules, moveObjectsToAnotherModule } from '../api/modulesApi';

export function* getModulesSaga() {
    try {
        const response = yield call(getModules);
        yield put(getModulesSuccess(response));
    } catch (error) {
        yield put(getModulesError(error));
    }
}

export function* addModuleSaga(params) {
    try {
        const response = yield call(addModule, params.payload);
        yield put(addModuleSuccess(response));
        yield put(getModulesRequest());
    } catch (error) {
        yield put(addModuleError(error));
    }
}

export function* editModuleSaga(params) {
    const { pk, name, parent } = params.payload;

    try {
        const response = yield call(editModule, pk, name, parent);
        yield put(editModuleSuccess(response));
        yield put(getModulesReset());
        yield put(getModulesRequest());
    } catch (error) {
        yield put(editModuleError(error));
    }
}

export function* deleteModuleSaga(params) {
    const { moduleIdToDelete, moduleIdToMove } = params.payload;

    try {
        yield call(moveObjectsToAnotherModule, moduleIdToDelete, moduleIdToMove);
        yield call(deleteModule, moduleIdToDelete);
        yield put(deleteModuleSuccess());
        yield put(getModulesRequest());
    } catch (error) {
        yield put(deleteModuleError(error));
    }
}

export default function* modulesSagaWatcher() {
    yield all([
        takeLatest(getModulesRequest, getModulesSaga),
        takeLatest(addModuleRequest, addModuleSaga),
        takeLatest(editModuleRequest, editModuleSaga),
        takeLatest(deleteModuleRequest, deleteModuleSaga),
    ]);
}
